/* eslint-disable arrow-body-style */

import React from 'react';
import { getTextWithHighlight } from '@intelligence/utils/commonUtils';
import {
  // getColumnPercentageWidth,
  formatDateStr,
} from '@gp/utils/common';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { GET_TEXT_WITH_HIGHLIGHT_OPTION } from '@gp/constants/const';

import type { TableColumn } from 'tea-component';
import type {
  IMetricsBaseMetric,
  IMetricsProjectMetric,
  IMetricsStudioFinancialMetric,
  IMetricsCommonSystemTerminology,
} from '@gp/types/metrics';

export function getBaseMetricsColumns<T extends IMetricsBaseMetric>(props: {
  keyword?: string;
  // definitionWidth: number | string;
}): TableColumn<T>[] {
  const {
    keyword,
    // definitionWidth,
  } = props || {};
  const keywordTmp = keyword?.trim() || '';

  return [
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'id',
      header: '#',
      // width: getColumnPercentageWidth(70),
      width: 70,
    }),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'metric',
      header: 'Metrics',
      // width: getColumnPercentageWidth(180),
      width: 180,
      formatter: (cvm) => {
        const { metric } = cvm || {};
        const metricTmp = metric?.trim() || '';
        if (!metricTmp) return '-';
        if (!keywordTmp) return metricTmp;
        return getTextWithHighlight(metricTmp, keywordTmp, GET_TEXT_WITH_HIGHLIGHT_OPTION);
      },
    }),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'definition',
      header: 'Definition',
      // width: definitionWidth,
    }),
  ];
}

export function getProjectStudioFinancialMetricsColumns<T extends IMetricsBaseMetric>(props: {
  keyword?: string;
  // definitionWidth: number | string;
}): TableColumn<T>[] {
  return [
    ...getBaseMetricsColumns<T>(props),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'data_source',
      header: 'Data Source',
      // width: getColumnPercentageWidth(180),
      width: 180,
    }),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'update_frequency',
      header: (
        <>
          Update
          <br />
          Frequency
        </>
      ),
      // width: getColumnPercentageWidth(140),
      width: 140,
    }),
  ];
}

export function getProjectMetricsColumns<T extends IMetricsProjectMetric>(props?: {
  keyword?: string;
}): TableColumn<T>[] {
  return [
    ...getProjectStudioFinancialMetricsColumns<T>({
      ...props,
      // definitionWidth: getColumnPercentageWidth(394),
    }),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'owner',
      header: 'Owner',
      // width: getColumnPercentageWidth(130),
      width: 130,
    }),
  ];
}

export function getStudioFinancialMetricsColumns<T extends IMetricsStudioFinancialMetric>(props?: {
  keyword?: string;
}): TableColumn<T>[] {
  return [
    ...getProjectStudioFinancialMetricsColumns<T>({
      ...props,
      // definitionWidth: getColumnPercentageWidth(204),
    }),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'earliest_data',
      header: (
        <>
          Earliest Data
          <br />
          Available
        </>
      ),
      width: 160,
      formatter: (cvm) => formatDateStr(cvm?.earliest_data, 'YYYY-MM') || '-',
    }),
    CommonColumnBuilders.buildPureTextColumn<T>({
      key: 'data_latency',
      header: (
        <>
          Current Data
          <br />
          Latency
        </>
      ),
      width: 160,
    }),
  ];
}

export function getCommonSystemTerminologyColumns<T extends IMetricsCommonSystemTerminology>(props: {
  keyword?: string;
}): TableColumn<T>[] {
  return [
    ...getBaseMetricsColumns<T>({
      ...props,
      // definitionWidth: getColumnPercentageWidth(844),
    }),
  ];
}
